import { useEffect, useState } from 'react';

const getPathname = () => window.location.pathname;

const listeners = new Set();
let historyPatched = false;
let originalPushState;
let originalReplaceState;

const notifyPathnameChange = () => {
  const pathname = getPathname();
  listeners.forEach(listener => listener(pathname));
};

const patchHistory = () => {
  if (historyPatched) return;

  historyPatched = true;
  originalPushState = window.history.pushState;
  originalReplaceState = window.history.replaceState;

  window.addEventListener('popstate', notifyPathnameChange);

  window.history.pushState = (...args) => {
    originalPushState.apply(window.history, args);
    notifyPathnameChange();
  };

  window.history.replaceState = (...args) => {
    originalReplaceState.apply(window.history, args);
    notifyPathnameChange();
  };
};

const unpatchHistory = () => {
  if (!historyPatched || listeners.size > 0) return;

  window.removeEventListener('popstate', notifyPathnameChange);

  if (originalPushState) {
    window.history.pushState = originalPushState;
  }

  if (originalReplaceState) {
    window.history.replaceState = originalReplaceState;
  }

  historyPatched = false;
  originalPushState = undefined;
  originalReplaceState = undefined;
};

export default function useBrowserPathname() {
  const [pathname, setPathname] = useState(getPathname);

  useEffect(() => {
    patchHistory();
    listeners.add(setPathname);

    return () => {
      listeners.delete(setPathname);
      unpatchHistory();
    };
  }, []);

  return pathname;
}
